import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * Login/Register gate modal.
 * Styled to match the existing SubscribeModal (same inline style approach).
 */
export default function AuthRequiredModal({
  open,
  onClose,
  nextPath = "/",
  title = "Premium content",
  message =
    "Learn more about this horoscope personality, compatibility, best matches, and challenges for each horoscope sign. Log in or register as a user to unlock.",
  loginLabel = "Login",
  registerLabel = "Register",
}) {
  const nav = useNavigate();
  if (!open) return null;

  const goLogin = () => {
    onClose?.();
    nav(`/login?next=${encodeURIComponent(nextPath)}`);
  };

  const goRegister = () => {
    onClose?.();
    nav(`/register?next=${encodeURIComponent(nextPath)}`);
  };

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
          <div>
            <h2 style={{ margin: 0 }}>{title}</h2>
            <p style={{ margin: "8px 0 0", opacity: 0.85 }}>{message}</p>
          </div>
          <button onClick={onClose} aria-label="Close" style={xBtn}>
            ✕
          </button>
        </div>

        <div style={{ display: "grid", gap: 12, marginTop: 16 }}>
          <button style={primaryBtn} onClick={goLogin}>
            <div style={{ fontWeight: 900, fontSize: 16 }}>{loginLabel}</div>
            <div style={{ fontSize: 12, opacity: 0.9 }}>Access your account</div>
          </button>

          <button style={secondaryBtn} onClick={goRegister}>
            <div style={{ fontWeight: 900, fontSize: 16 }}>{registerLabel}</div>
            <div style={{ fontSize: 12, opacity: 0.85 }}>Create a free account</div>
          </button>
        </div>
      </div>
    </div>
  );
}

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.65)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
  padding: 16,
};

const modal = {
  width: "min(720px, 96vw)",
  background: "#fff",
  borderRadius: 18,
  padding: 18,
  boxShadow: "0 20px 50px rgba(0,0,0,0.35)",
};

const primaryBtn = {
  width: "100%",
  textAlign: "left",
  padding: "14px 16px",
  borderRadius: 16,
  border: "1px solid rgba(0,0,0,0.08)",
  background: "#f19807",
  color: "#fff",
  cursor: "pointer",
};

const secondaryBtn = {
  width: "100%",
  textAlign: "left",
  padding: "14px 16px",
  borderRadius: 16,
  border: "1px solid rgba(0,0,0,0.12)",
  background: "#fff",
  color: "#222",
  cursor: "pointer",
};

const xBtn = {
  border: "none",
  background: "#e46f01",
  borderRadius: 10,
  width: 36,
  height: 36,
  cursor: "pointer",
  fontWeight: 900,
  color: "#fff",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  fontSize: 18,
  lineHeight: 1,
};
